module.exports = __webpack_public_path__ + "static/media/arrangement_card.5675549c.jpg";